import React from "react";
import { Tooltip } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import { CardProps, copyCard, InputTypes, removeCard, StateProps, toggleIsRequired } from "../../store";
import * as S from "./styles";
import { HiOutlineTrash } from "react-icons/hi2";
import { IoDuplicateOutline } from "react-icons/io5";
import TeamNumberInput from "../TeamNumberInput";

const CardFooter = ({ id }: Pick<CardProps, "id">) => {
  const dispatch = useDispatch();

  const isRequired = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.isRequired;
  });

  const handleChange = () => {
    dispatch(toggleIsRequired({ id }));
  };

  const isSection = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.inputType === InputTypes.SECTION || currentCard.inputType === InputTypes.ADDABLE_SECTION;
  });

  const isAddableSection = useSelector((state: StateProps) => {
    const currentCard = state.cards.find((card) => card.id === id) as CardProps;
    return currentCard.inputType === InputTypes.ADDABLE_SECTION;
  });

  return (
    <S.Container>
      {isAddableSection && <TeamNumberInput id={id} />}
      <Tooltip title="복사">
        <S.Copy
          onClick={(e) => {
            e.stopPropagation();
            dispatch(copyCard({ cardId: id, copiedCardId: String(Date.now()) }));
          }}
        >
          <IoDuplicateOutline size={25} />
        </S.Copy>
      </Tooltip>
      <Tooltip title="삭제">
        <S.Trash>
          <HiOutlineTrash
            size={25}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(removeCard({ cardId: id }));
            }}
          />
        </S.Trash>
      </Tooltip>
      {!isSection &&
      <S.FormControlLabel
        control={<S.Switch name="required" checked={isRequired} onChange={handleChange} />}
        label="필수"
        labelPlacement="start"
        onClick={(e) => {
          e.stopPropagation();
        }}
      />}
    </S.Container>
  );
};

export default CardFooter;
